module.exports = __webpack_public_path__ + "media/67.aa0f6c20.mp3";